<template>
  <section class="inspection-highlights" :style="sectionStyle">
    <div class="inspection-highlights__inner">
      <div class="inspection-highlights__header">
        <span class="inspection-highlights__eyebrow">检验检测动态</span>
        <h2 class="inspection-highlights__title">关注检测质量 赋能产业升级</h2>
        <p class="inspection-highlights__desc">
          依托专业实验室平台、标准化质量体系和经验丰富的技术团队，
          我们持续开展食品、环境、药品、化妆品等领域的检验检测服务，
          以可靠数据支撑企业质量提升与安全管理。
        </p>
        <a href="javascript:void(0);" class="inspection-highlights__link" @click="goToAbout">
          了解精科信检测
          <span class="inspection-highlights__link-icon"></span>
        </a>
      </div>

      <div class="inspection-highlights__cards">
        <article
          v-for="item in cards"
          :key="item.id"
          class="inspection-highlights__card"
        >
          <div class="inspection-highlights__image-wrap">
            <img :src="item.image" :alt="item.title" class="inspection-highlights__image">
          </div>
          <p class="inspection-highlights__meta">{{ item.date }}</p>
          <h3 class="inspection-highlights__card-title">{{ item.title }}</h3>
          <p class="inspection-highlights__card-desc">{{ item.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import labImage1 from '@/assets/index/shiyanshi1.png'
import labImage2 from '@/assets/index/shiyanshi2.png'
import labImage3 from '@/assets/index/shiyanshi3.png'
import labImage4 from '@/assets/index/shiyansh4.png'
import row3Bg from '@/assets/row3_bg.png'

export default {
  name: 'InspectionHighlights',
  computed: {
    sectionStyle() {
      return {
        backgroundImage: `
          linear-gradient(rgba(247, 247, 245, 0.9), rgba(247, 247, 245, 0.9)),
          linear-gradient(rgba(16, 24, 40, 0.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(16, 24, 40, 0.05) 1px, transparent 1px),
          url(${row3Bg})
        `
      }
    }
  },
  data() {
    return {
      cards: [
        {
          id: 1,
          date: '2026-05-01',
          title: '食品检测服务持续升级，助力企业把控出厂品质',
          description: '围绕原料筛查、过程监控与成品验证，提供高效可靠的检测支持。',
          image: labImage1
        },
        {
          id: 2,
          date: '2026-04-24',
          title: '实验室标准化流程运行，检测结果更加稳定可信',
          description: '通过规范化操作、仪器校准和全过程质控，确保数据真实有效。',
          image: labImage2
        },
        {
          id: 3,
          date: '2026-04-19',
          title: '专业技术团队协同分析，为客户提供精准解决方案',
          description: '从样品受理到结果研判，形成覆盖多场景的技术支撑能力。',
          image: labImage3
        },
        {
          id: 4,
          date: '2026-04-12',
          title: '多领域检验检测联动推进，守护安全生产与公众健康',
          description: '面向环境、药品、化妆品等领域，构建一站式检测服务体系。',
          image: labImage4
        }
      ]
    }
  },
  methods: {
    goToAbout() {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'about' }
      }))
    }
  }
}
</script>

<style scoped>
.inspection-highlights {
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: clamp(28px, 4vh, 48px) 0;
  background-color: #f7f7f5;
  background-repeat: no-repeat, repeat, repeat, no-repeat;
  background-position: center, 0 0, 0 0, center;
  background-size: cover, 180px 180px, 180px 180px, cover;
  overflow: hidden;
  position: relative;
}

.inspection-highlights::before,
.inspection-highlights::after {
  position: absolute;
  color: rgba(17, 24, 39, 0.04);
  font-size: 220px;
  font-weight: 700;
  line-height: 1;
  pointer-events: none;
}

.inspection-highlights::before {
  content: 'JK';
  top: 12px;
  left: 24px;
}

.inspection-highlights::after {
  content: 'XD';
  top: 24px;
  right: -16px;
}

.inspection-highlights__inner {
  position: relative;
  z-index: 1;
  width: min(1240px, calc(100% - 80px));
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.inspection-highlights__header {
  max-width: 780px;
  margin-bottom: clamp(24px, 3vh, 40px);
}

.inspection-highlights__eyebrow {
  display: inline-block;
  margin-bottom: 14px;
  color: #d7922d;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.inspection-highlights__title {
  margin: 0 0 18px;
  color: #1f2937;
  font-size: clamp(34px, 3vw, 48px);
  line-height: 1.18;
  font-weight: 700;
}

.inspection-highlights__desc {
  margin: 0;
  color: #4b5563;
  font-size: 16px;
  line-height: 1.9;
}

.inspection-highlights__link {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  margin-top: 28px;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.inspection-highlights__link-icon {
  width: 28px;
  height: 28px;
  border: 1px solid rgba(215, 146, 45, 0.45);
  border-radius: 50%;
  position: relative;
}

.inspection-highlights__link-icon::before,
.inspection-highlights__link-icon::after {
  content: '';
  position: absolute;
  background-color: #d7922d;
}

.inspection-highlights__link-icon::before {
  top: 13px;
  left: 8px;
  width: 10px;
  height: 1px;
}

.inspection-highlights__link-icon::after {
  top: 10px;
  right: 8px;
  width: 5px;
  height: 5px;
  border-top: 1px solid #d7922d;
  border-right: 1px solid #d7922d;
  transform: rotate(45deg);
  background: transparent;
}

.inspection-highlights__cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.inspection-highlights__card {
  min-width: 0;
}

.inspection-highlights__image-wrap {
  overflow: hidden;
  background: #dbe7ee;
}

.inspection-highlights__image {
  display: block;
  width: 100%;
  aspect-ratio: 1.08 / 0.64;
  object-fit: cover;
  transition: transform 0.45s ease;
}

.inspection-highlights__card:hover .inspection-highlights__image {
  transform: scale(1.04);
}

.inspection-highlights__meta {
  margin: 12px 0 8px;
  color: #9ca3af;
  font-size: 12px;
  line-height: 1.4;
}

.inspection-highlights__card-title {
  margin: 0 0 8px;
  color: #111827;
  font-size: 18px;
  line-height: 1.45;
  font-weight: 600;
}

.inspection-highlights__card-desc {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.65;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 1200px) {
  .inspection-highlights__title {
    font-size: 40px;
  }

  .inspection-highlights__cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .inspection-highlights {
    padding: 56px 0;
    background-size: cover, 120px 120px, 120px 120px, cover;
  }

  .inspection-highlights::before,
  .inspection-highlights::after {
    display: none;
  }

  .inspection-highlights__inner {
    width: calc(100% - 32px);
  }

  .inspection-highlights__header {
    margin-bottom: 36px;
  }

  .inspection-highlights__title {
    font-size: 30px;
  }

  .inspection-highlights__desc {
    font-size: 14px;
    line-height: 1.8;
  }

  .inspection-highlights__cards {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .inspection-highlights__card-title {
    font-size: 18px;
  }
}
</style>
